import React from 'react';
import { Sparkles } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import RichTextEditor from '@/components/RichTextEditor';
import { INSTITUTIONAL_TEXT_TEMPLATES } from './constants';

export const LayoutStyleSection = ({ brandingData, setBrandingData }) => {
  const hasInstitutionalLayout =
    brandingData.layout_style === 'whistlelink_style' || brandingData.layout_style === 'whistle';

  return (
  <>
    <div>
      <Label className="text-base font-medium text-slate-900">Estilo da Landing Page Pública</Label>
      <p className="text-sm text-slate-500 mb-3">Escolha o layout da página pública de denúncia deste canal.</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <label
          className={`flex items-start gap-3 p-3 border rounded-lg cursor-pointer transition ${brandingData.layout_style === 'classic' ? 'border-indigo-500 bg-indigo-50' : 'border-slate-300 bg-white'}`}
          data-testid="layout-style-classic-option"
        >
          <input
            type="radio"
            name="layout_style"
            checked={brandingData.layout_style === 'classic'}
            onChange={() => setBrandingData(prev => ({ ...prev, layout_style: 'classic' }))}
            className="mt-1"
          />
          <div className="text-sm">
            <div className="font-medium text-slate-900">Clássico</div>
            <div className="text-slate-500">Banner + formulário direto (layout atual).</div>
          </div>
        </label>
        <label
          className={`flex items-start gap-3 p-3 border rounded-lg cursor-pointer transition ${brandingData.layout_style === 'whistlelink_style' ? 'border-indigo-500 bg-indigo-50' : 'border-slate-300 bg-white'}`}
          data-testid="layout-style-whistlelink-option"
        >
          <input
            type="radio"
            name="layout_style"
            checked={brandingData.layout_style === 'whistlelink_style'}
            onChange={() => setBrandingData(prev => ({ ...prev, layout_style: 'whistlelink_style' }))}
            className="mt-1"
          />
          <div className="text-sm">
            <div className="font-medium text-slate-900">Institucional</div>
            <div className="text-slate-500">Hero + cartões de proteção + texto institucional + botões laterais (Submeter/Acompanhar).</div>
          </div>
        </label>
        <label
          className={`flex items-start gap-3 p-3 border rounded-lg cursor-pointer transition ${brandingData.layout_style === 'whistle' ? 'border-indigo-500 bg-indigo-50' : 'border-slate-300 bg-white'}`}
          data-testid="layout-style-whistle-option"
        >
          <input
            type="radio"
            name="layout_style"
            checked={brandingData.layout_style === 'whistle'}
            onChange={() => setBrandingData(prev => ({ ...prev, layout_style: 'whistle' }))}
            className="mt-1"
          />
          <div className="text-sm">
            <div className="font-medium text-slate-900">Whistle (CogniEtica)</div>
            <div className="text-slate-500">Layout premium com o slug do canal em destaque e branding CogniEtica.</div>
          </div>
        </label>
      </div>
    </div>

    {hasInstitutionalLayout && (
      <div className="space-y-4">
        <div>
          <div className="flex items-center justify-between">
            <Label>Texto Institucional</Label>
            <div className="flex gap-1.5">
              {INSTITUTIONAL_TEXT_TEMPLATES.map(t => (
                <button
                  key={t.key}
                  type="button"
                  onClick={() => setBrandingData(prev => ({ ...prev, institutional_text: t.html }))}
                  className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition"
                  data-testid={`institutional-template-${t.key}`}
                >
                  <Sparkles className="w-3 h-3" /> {t.label}
                </button>
              ))}
            </div>
          </div>
          <p className="text-xs text-slate-500 mb-1">O que reportar, como é tratada a denúncia, denúncia externa, anonimato… (ou use um modelo acima como ponto de partida)</p>
          <RichTextEditor
            value={brandingData.institutional_text}
            onChange={(html) => setBrandingData(prev => ({ ...prev, institutional_text: html }))}
            placeholder="Escreva o texto institucional da página de boas-vindas…"
            testid="institutional-text-editor"
          />
        </div>
        <div>
          <Label>Email de Suporte do Canal</Label>
          <p className="text-xs text-slate-500 mb-1">
            Endereço apresentado na secção "Suporte" da landing pública. Se vazio, é usado o email de suporte global da plataforma.
          </p>
          <Input
            type="email"
            value={brandingData.support_email || ''}
            onChange={(e) => setBrandingData(prev => ({ ...prev, support_email: e.target.value }))}
            placeholder="compliance@empresa.pt"
            className="bg-white border-slate-300 text-slate-900"
            data-testid="support-email-input"
          />
        </div>
        <div>
          <Label>Mensagem Personalizada de Suporte (opcional)</Label>
          <p className="text-xs text-slate-500 mb-1">
            Texto rico apresentado na secção "Suporte" em vez da mensagem padrão. Ideal para incluir uma assinatura, contactos adicionais, links ou horários.
          </p>
          <RichTextEditor
            value={brandingData.support_signature || ''}
            onChange={(html) => setBrandingData(prev => ({ ...prev, support_signature: html }))}
            placeholder="Ex.: Contacte o Compliance Officer em compliance@empresa.pt · Linha directa: 800 000 000 · Horário: Seg-Sex 09h-18h"
            testid="support-signature-editor"
          />
        </div>
      </div>
    )}
  </>
  );
};

